// GA4 measurement id. Loaded by the gtag snippet in index.html; the env var can
// override it per-build, otherwise we fall back to the live property id.
const GA_ID = import.meta.env.VITE_GA_TRACKING_ID || 'G-FQVN87YM4R'

interface AnalyticsEvent {
  name: string
  properties?: Record<string, any>
}

class Analytics {
  private gtag: any

  constructor() {
    this.gtag = (window as any).gtag
  }

  track(event: AnalyticsEvent) {
    if (typeof this.gtag === 'function') {
      this.gtag('event', event.name, event.properties)
    }

    console.log('Analytics:', event)
  }

  page(path: string, title?: string) {
    if (typeof this.gtag === 'function') {
      this.gtag('config', import.meta.env.VITE_GA_TRACKING_ID, {
        page_path: path,
        page_title: title,
      })
    }

    console.log('Page view:', { path, title })
  }
}

export const analytics = new Analytics()

export const trackEvent = (name: string, properties?: Record<string, any>) => {
  analytics.track({ name, properties })
}

export const trackPageView = (path: string, title?: string) => {
  analytics.page(path, title)
}
